export default "__VITE_ASSET__CIDZeqV1__"